export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_ACTOR":
      return action.payload;
    default:
      return state;
  }
};
